import React from 'react';
import { useAppUser } from '@bechtel/client-common';
import { AuthPermission, AuthScope } from '@bechtel/types';

export function useReportPermissions() {
  const { hasPermissionScope } = useAppUser();
  const reportPermissions = React.useMemo(() => {
    const canViewReports = hasPermissionScope({
      permission: AuthPermission.VIEW_REPORT,
      scope: AuthScope.APPLICATION,
    });
    return { canViewReports };
  }, [hasPermissionScope]);
  return reportPermissions;
}
